import { castArray } from 'lodash/fp';
import { API_URL } from '../../../app-config/constants';
import type { EmailTemplateDto, EmailTemplateType, EmailTemplateTypeDto } from '../../../types/EmailTemplateDto';
import { getLaddaId } from '../../../types/EmailTemplateDto';
import type { ModuleType } from '../../react/components/EditorWithReplacements/types';
import { get, put, remove } from '../request';

// not using ladda's idFrom because that currently doesn't work with COMMAND or UPDATE
const addId = (template: EmailTemplateDto) => ({
    ...template,
    id: getLaddaId(template),
});
const addIds = (templates: EmailTemplateDto[]) => templates.map(addId);

getTemplates.operation = 'READ';
export function getTemplates(
    types?: EmailTemplateType | EmailTemplateType[],
    options: { reviewCycleId?: string; feedbackCycleId?: string; moduleType?: ModuleType } = {}
) {
    return get<EmailTemplateDto[]>(`${API_URL}/email-templates`, {
        getData: {
            types: types && castArray(types).join(','),
            ...options,
        },
    }).then(addIds);
}

saveTemplate.operation = 'COMMAND';
export function saveTemplate(emailTemplate: EmailTemplateDto) {
    return put<EmailTemplateDto>(`${API_URL}/email-templates/${emailTemplate.templateType.type}`, {
        postData: emailTemplate,
    }).then(addId);
}

resetTemplate.operation = 'COMMAND';
export function resetTemplate(emailTemplateType: EmailTemplateTypeDto) {
    return remove<EmailTemplateDto>(`${API_URL}/email-templates/${emailTemplateType.type}`).then(addId);
}

invalidate.invalidates = ['getTemplates'];
export function invalidate() {
    return Promise.resolve();
}
